"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CurrencyInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _setPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/setPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _currenciesConfig = _interopRequireDefault(require("@active/core/currency/currenciesConfig"));
var _numberFormatter = require("@active/core/number/numberFormatter");
var _currency = require("@active/core/currency");
var _InputAddon = _interopRequireDefault(require("../InputAddon"));
var _NumericInput = _interopRequireDefault(require("../NumericInput"));
var _constants = require("../constants");
var _excluded = ["className", "code", "codeMode", "codePosition", "value", "onBlur", "onChange", "onKeyDown", "renderCode", "locale"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), (0, _setPrototypeOf2["default"])(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return (0, _inherits2["default"])(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
var MAX_INTEGER_LENGTH = 16;
var MAX_DECIMAL_INTEGER_LEN = 14;
var MAX_DECIMAL_DECIMAL_LEN = 2;
var CODE_ADDON_POSITION_MAP = {
  prefix: 'preAddon',
  suffix: 'postAddon'
};
function isDecimalPoint(key) {
  return key === _constants.KEY_VALUES.PERIOD;
}
function isIntegerOnly(code) {
  var integerOnly = _currenciesConfig["default"][code].formatConfig.integerOnly;
  return integerOnly;
}
function formatter(value, _ref) {
  var code = _ref.code;
  var integerOnly = isIntegerOnly(code);
  if (value) {
    return integerOnly ? (0, _numberFormatter.formatNumber)({
      decimalPart: 0
    })(value) : (0, _numberFormatter.formatNumber)({
      decimalPart: 2
    })(value);
  }
  return '';
}
function isValidNumber(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    integerOnly = _ref2.integerOnly;
  var _ref3 = value.match(/*#__PURE__*/_wrapRegExp(/^\x2D?(\d*)(\.?)(\d*)$/, {
      integerPart: 1,
      point: 2,
      decimalPart: 3
    })),
    _ref3$groups = _ref3.groups,
    _ref3$groups2 = _ref3$groups === void 0 ? {
      integerPart: '',
      point: null,
      decimalPart: ''
    } : _ref3$groups,
    _ref3$groups2$integer = _ref3$groups2.integerPart,
    integerPart = _ref3$groups2$integer === void 0 ? '' : _ref3$groups2$integer,
    isDecimal = _ref3$groups2.point,
    _ref3$groups2$decimal = _ref3$groups2.decimalPart,
    decimalPart = _ref3$groups2$decimal === void 0 ? '' : _ref3$groups2$decimal;
  return integerOnly ? !isDecimal && integerPart.length <= MAX_INTEGER_LENGTH : integerPart.length <= MAX_DECIMAL_INTEGER_LEN && decimalPart.length <= MAX_DECIMAL_DECIMAL_LEN;
}
function renderCode(code, codeMode, locale) {
  return codeMode === 'symbol' ? (0, _currency.symbolOf)(code, locale) : code;
}
var handleNegativeNumber = function handleNegativeNumber(value) {
  var handledValue = value;
  if (value === '-') {
    handledValue = '';
  } else if (value !== '' && +value < 0) {
    handledValue = Math.abs(+value);
  }
  return handledValue;
};
var CurrencyInput = exports.CurrencyInput = function CurrencyInput(_ref4, ref) {
  var className = _ref4.className,
    _ref4$code = _ref4.code,
    code = _ref4$code === void 0 ? 'USD' : _ref4$code,
    _ref4$codeMode = _ref4.codeMode,
    codeMode = _ref4$codeMode === void 0 ? 'code' : _ref4$codeMode,
    _ref4$codePosition = _ref4.codePosition,
    codePosition = _ref4$codePosition === void 0 ? 'suffix' : _ref4$codePosition,
    currencyValue = _ref4.value,
    onBlur = _ref4.onBlur,
    onChange = _ref4.onChange,
    onKeyDown = _ref4.onKeyDown,
    renderCodeProp = _ref4.renderCode,
    _ref4$locale = _ref4.locale,
    locale = _ref4$locale === void 0 ? 'en_US' : _ref4$locale,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  var _useState = (0, _react.useState)(formatter(currencyValue, {
      code: code
    })),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    stateValue = _useState2[0],
    setStateValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (currencyValue !== stateValue && formatter(currencyValue, {
      code: code
    }) !== stateValue) {
      setStateValue(formatter(currencyValue, {
        code: code
      }));
    }
  }, [code, currencyValue, stateValue]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    var value = e.target.value;
    onBlur === null || onBlur === void 0 || onBlur(e);
    setStateValue(formatter(value, {
      code: code
    }));
  }, [code, onBlur, setStateValue]);
  var handleChange = (0, _react.useCallback)(function (value) {
    var integerOnly = isIntegerOnly(code);
    if (!value || isValidNumber(value.toString(), {
      integerOnly: integerOnly
    })) {
      var handledValue = handleNegativeNumber(value);
      onChange === null || onChange === void 0 || onChange(handledValue);
      setStateValue(handledValue);
    }
  }, [code, onChange, setStateValue]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    var integerOnly = isIntegerOnly(code);
    var key = e.key;
    // Disallow decimal point when `integerOnly`
    if (integerOnly && isDecimalPoint(key)) {
      e.preventDefault();
    }
    onKeyDown && onKeyDown(e);
  }, [code, onKeyDown]);
  var addon = (0, _react.useMemo)(function () {
    var _renderCodeProp;
    return (0, _defineProperty2["default"])({}, CODE_ADDON_POSITION_MAP[codePosition], /*#__PURE__*/_react["default"].createElement(_InputAddon["default"], {
      "data-testid": "currency-input-code",
      "aria-hidden": "true"
    }, (_renderCodeProp = renderCodeProp === null || renderCodeProp === void 0 ? void 0 : renderCodeProp(code)) !== null && _renderCodeProp !== void 0 ? _renderCodeProp : renderCode(code, codeMode, locale)));
  }, [code, codeMode, codePosition, locale, renderCodeProp]);
  return /*#__PURE__*/_react["default"].createElement(_NumericInput["default"], (0, _extends2["default"])({
    "data-testid": "currency-input"
  }, (0, _omit["default"])(['value', 'onTouched', 'onKeyDown'])(rest), {
    className: (0, _classnames["default"])('currency-input', className),
    value: stateValue,
    ref: ref,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    nonNegative: true
  }, addon));
};
var ForwardRefCurrencyInput = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(CurrencyInput);
var _default = exports["default"] = ForwardRefCurrencyInput;